<template>
  <div>
    <div style="width: 100vw; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div 
        :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; padding-bottom: '+($store.getters.getScreenWidth>=650 ? '' : '40px')+'; max-width: 1920px; margin-top: 0px; display: flex; flex-direction: column; justify-content: center; align-items: center;'">
        <div :style="'display: flex; flex-direction: column; padding-bottom: 100px; width: 100%; text-align: center;'">            
          <div style="margin-top: 10px; width: 100%; text-align: center;">
            <video 
              controls 
              autoplay 
              :style="{width: getVideoWidth+'px'}">
              <source src="https://etacdn.b-cdn.net/eta-help-video/ETA-Presentation.mp4" type="video/mp4">
            </video>
          </div>
          
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
    data() {
      return {
        video_fullscreen: false
      }
    },
    computed: {
      getVideoWidth() {
        let screenWidth = this.$store.getters.getScreenWidth

        return (screenWidth<=850 ? screenWidth*95/100 : screenWidth*80/100)
      },
      getFont54() {
        if(this.$store.getters.getScreenWidth<560 && this.$store.getters.getScreenWidth>429) {
          return '34px'
        } else if(this.$store.getters.getScreenWidth<=429 && this.$store.getters.getScreenWidth>373) {
          return '30px'
        } else if(this.$store.getters.getScreenWidth<=373) {
          return '24px'
        }
        return this.$store.getters.getFontSizes.f54
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Screenshots/Row1.vue